import React, { useEffect, useState } from "react";
// import "../../assets/scss/generic/tocDropdown.scss";
import { IListObj } from "../../../types/genericTypes";

export interface IChartTocDropdownProps {
  selectedValue?: number | string; // default selected value
  dropdownOptions: Array<IListObj>; // list of all options in dropdown
  onSelect: (id: string | number) => void; // the function to be called onSelect
  showPrimary?: boolean; // true if need to show star, otherwise false
  showClose?: boolean; // true if need to show close button, otherwise false
  disabled?: boolean; //disable the dropdown
  isSearchable: boolean; // for searchable dropdown list
}

const ChartTocDropdown: React.FC<IChartTocDropdownProps> = (
  props: IChartTocDropdownProps
) => {
  /**
   * state and function for isDropdownOpen
   * selectedValue type is boolean
   * setSelectedValue(boolean)
   */
  const [dropDownOption, setDropDownOption] = useState<Array<IListObj>>();
  const [search, setSearch] = useState<any>();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  /**
   * called when user selects an option
   * @param id id of the selected option
   * @returns onSelect prop passed from parent
   */
  function optionSelected(id: string | number) {
    setIsDropdownOpen(false);
    return props.onSelect(id);
  }

  // function handleChange(e: any) {
  //   setSearch(e.target.value);
  //   const list = props.dropdownOptions.filter((opt) => {
  //     if (opt.display.toLowerCase().includes(e.target.value.toLowerCase()))
  //       return opt;
  //   });
  //   setIsDropdownOpen(true);
  //   setDropDownOption(list);
  // }
  // Find the selected object
  const selectedOption = props.dropdownOptions.find(
    (option) => props.selectedValue === option.value
  );
  useEffect(() => {
    const selectedOption = props.dropdownOptions.find(
      (option) => props.selectedValue === option.value
    );
    setSearch(selectedOption?.display);
    const options = props.dropdownOptions.filter(
      (opt) => props.selectedValue !== opt.value
    );
    setDropDownOption(options);
  }, [props.selectedValue, props.dropdownOptions]);

  useEffect(() => {
    /**
     *if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown_wrap" ref={wrapperRef}>
      <button
        className="dropdown_button pointer"
        onClick={(e) => {
          e.preventDefault();
          !(e as any).target.className.includes("edel-icon-close") &&
            setIsDropdownOpen(true);
        }}
        disabled={props.disabled}
        type={"button"}
      >
        {/* show the value of selectedValue */}
        <span className="selected">
          {selectedOption?.display}
          {/* Show star only if primary is to be shown and first option is selected */}
          {props.showPrimary && selectedOption?.primary && (
            <i className="star edel-icon-star" />
          )}
        </span>
        {props.showClose && props.selectedValue ? (
          <i className="edel-icon-close" onClick={() => optionSelected("")} />
        ) : (
          <i className="edel-icon-arrow-down" />
        )}
      </button>

      {/* when dropdown is open show overlay and content */}
      {isDropdownOpen && (
        <>
          {/* Overlay covers the whole screen. When overlay is clicked, close the dropdown. */}
          <div
            className="dropdown_overlay"
            onClick={() => setIsDropdownOpen(false)}
          />

          {/* Dropdown list */}
          <ul className="dropdown_content">
            {dropDownOption &&
              dropDownOption.length > 0 &&
              dropDownOption.map((option, index) => (
                <li
                  className={
                    "dropdown_item" +
                    (option.value === props.selectedValue ? " active" : "")
                  }
                  key={index}
                  onClick={() => optionSelected(option.value)}
                >
                  {option.display}
                  {/* <div className="dropdown_item_inner">
                    <div>
                      show tick only if this option is selected
                      <span className="tick_container">
                        {option.value === props.selectedValue && (
                          <i className="tick edel-icon-tick" />
                        )}
                      </span>
                      <label>{option.display}</label>
                    </div>
                    {option.primary && props.showPrimary && (
                      <div>
                        <i className="star edel-icon-star" />
                      </div>
                    )}
                  </div> */}
                </li>
              ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default ChartTocDropdown;
